import dayjs from "dayjs";
import { useAuth } from "react-oidc-context";
import { LoaderFunctionArgs, useLoaderData, useNavigate } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { DoaForecast } from "./DoaForecast";
import { DoaForecastData } from "./DoaForecastData";

export const doaForecastRouteLoader = async ({ request, params }: LoaderFunctionArgs) => {
  return await doFetch('doa-forecast', { signal: request.signal }, true, false)
}

export const DoaForecastRoute = () => {
  const data = useLoaderData() as DoaForecastData;
  const navigate = useNavigate();
  const auth = useAuth();
  const signedIn = auth.isAuthenticated;
  const isDOAAdmin = signedIn && auth.user?.profile.isDoaAdmin === "True"

  const onSelectDispatch = (dispatch: string, date: string) => {
    const paramsSubStr = `${dispatch.toLowerCase()}/${dayjs(date, 'DD.MM.YYYY').format('DDMMYYYY')}`
    const url = isDOAAdmin ? `/doa-forecast/doa-admin/${paramsSubStr}/stats` : `/doa-forecast-stats/${paramsSubStr}`;
    navigate(url);
  }

  return <DoaForecast
    onSelectDispatch={onSelectDispatch}
    data={data.availabiltyStats}
  />
}